export default __webpack_public_path__ + "images/RRV.5c9f2c5.png";